import { useClearRefinements, type UseClearRefinementsProps } from "react-instantsearch";
import {useConfigContext} from "../../ConfigProvider.tsx";
import {useDateFilterContext} from "../../app-instantsearch/providers/DateFilterProvider.tsx";
export function ResetFilters(props: UseClearRefinementsProps) {
	const { refine, canRefine } = useClearRefinements(props);
	const { tc } = useConfigContext();
	const { reset: resetDateRange, startDate, endDate } = useDateFilterContext();

	const hasDateFilter = !!startDate && !!endDate;

	const handleReset = () => {
		if (canRefine) refine();
		if (hasDateFilter) resetDateRange();
	};

	if (!canRefine && !hasDateFilter) return null;

	return (
		<button className={"resetFilterButton"} onClick={handleReset}>
			<i className={"iconNew iconNew-trash"} aria-hidden={true} />
			<span>{tc.resetFilters}</span>
		</button>
	);
}
